import { useParams, useNavigate } from "react-router-dom";

function ProductDetails() {
  const { product } = useParams();
  const navigate = useNavigate();

  const products = {
    hume: {
      title: "Hume Pipes",
      description:
        "High-quality Hume Pipes manufactured for drainage, sewerage, irrigation and infrastructure projects.",

      sizes: [
        {
          size: "300 mm",
          length: "2.5 Meter",
          class: "NP2, NP3, NP4",
        },
        {
          size: "450 mm",
          length: "2.5 Meter",
          class: "NP2, NP3, NP4",
        },
        {
          size: "600 mm",
          length: "2.5 Meter",
          class: "NP2, NP3, NP4",
        },
      ],
    },

    rcc: {
      title: "RCC Pipes",
      description:
        "Durable RCC Pipes suitable for drainage, sewerage and civil construction projects.",

      sizes: [
        {
          size: "300 mm",
          length: "2.5 Meter",
          class: "NP2, NP3, NP4",
        },
        {
          size: "450 mm",
          length: "2.5 Meter",
          class: "NP2, NP3, NP4",
        },
        {
          size: "600 mm",
          length: "2.5 Meter",
          class: "NP2, NP3, NP4",
        },
        {
          size: "750 mm",
          length: "2.5 Meter",
          class: "NP2",  
        },
        {
          size: "900 mm",
          length: "2.5 Meter",
          class: "NP2, NP3, NP4",  
        },
        {
          size: "1000 mm",
          length: "2.5 Meter",
          class: "NP3, NP4",
        },
        {
          size: "1200 mm",
          length: "2.5 Meter",
          class: "NP3, NP4",
        }
      ],
    },

    septic: {
      title: "Shankar Septic Tank",
      description:
        "Strong and durable septic tank solutions available in different capacities.",

      sizes: [
        {
          size: "24 inch",
          capacity  : "20 Persons in a day",
          क्षमता  : "एक दिन में 20 लोग"
        },
        {
          size: "30 inch",
          capacity  : "35 Persons in a day",
          क्षमता  : "एक दिन में 35 लोग",               
        },
        {
          size: "36 inch",
          capacity  : "50 Persons in a day",
          क्षमता  : "एक दिन में 50 लोग",
        },
        {
          size: "42 inch",
          capacity  : "75 Persons in a day",
          क्षमता  : "एक दिन में 75 लोग",
        },
        {
          size: "48 inch",
          capacity  : "100 Persons in a day",
          क्षमता  : "एक दिन में 100 लोग",
        },
      ],
    },

    paver: {
      title: "Paver Concrete Blocks",
      description:
        "Durable concrete paver blocks suitable for roads, pathways, parking areas and other applications.",

      sizes: [
        {
          type: "Zig-Zag paver brick",
          thickness: "40 mm, 60 mm, 80 mm",
        },
        {
          type: "Dumble paver brick",
          thickness: "40 mm, 60 mm, 80 mm",
        },
      ],
      
      note: "Other models are also available on request",
      noteHindi: "अनुरोध पर अन्य मॉडल भी उपलब्ध हैं",
        
    },
  };

  const selectedProduct = products[product];

  if (!selectedProduct) {
    return (
      <div className="product-details-page">
        <h2>Product Not Found</h2>

        <button onClick={() => navigate("/")}>
          ← Back to Home
        </button>
      </div>
    );
  }

  return (
    <div className="product-details-page">

      <h1>{selectedProduct.title}</h1>

      <p className="product-description">
        {selectedProduct.description}
      </p>

      <h2>Available Sizes & Specifications</h2>

      <div className="product-table-container">

        <table className="product-table">

          <thead>
            <tr>
              {Object.keys(selectedProduct.sizes[0]).map((key) => (
                <th key={key}>
                  {key.toUpperCase()}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>

            {selectedProduct.sizes.map((item, index) => (

              <tr key={index}>

                {Object.values(item).map((value, i) => (
                  <td key={i}>{value}</td>
                ))}

              </tr>

            ))}

          </tbody>

        </table>

      </div>

      {/* Product Note */}
      {selectedProduct.note && (
        <div className="product-note">
          <strong>Note:</strong> {selectedProduct.note}

          <br />

          <span>{selectedProduct.noteHindi}</span>
        </div>
      )}
      

      <button
        className="back-button"
        onClick={() => navigate("/")}
      >
        ← Back to Home
      </button>

    </div>
  );
}

export default ProductDetails;